const enOrdinalRules = new Intl.PluralRules('en-US', {type: 'ordinal'})

const suffixes: Readonly<Record<Intl.LDMLPluralRule, string>> = {
  zero: 'th',
  one: 'st',
  two: 'nd',
  few: 'rd',
  many: 'th',
  other: 'th',
} as const

export const formatOrdinals = (n: number): string => {
  const rule = enOrdinalRules.select(n)
  return `${n}${suffixes[rule]}`
}
